import Immutable from 'immutable';
import listService from 'ListService.js';
import viewManagerService from 'ViewManagerService';

const columnInfo = {
    'tbl_button' : {name: 'Button', factoryKey: 'buttonColumn'},
    'tbl_tickbox' : {name: 'Checkbox', factoryKey: 'checkboxColumn'},
    'tbl_childFormButton' : {name: 'Child App Button', factoryKey: 'childFormColumn'},
    'tbl_dateInput' : {name: 'Date Input', factoryKey: 'dateInputColumn'},
    'tbl_dropDown' : {name: 'Drop-Down', factoryKey: 'dropdownColumn'},
    'tbl_fileAttachment' : {name: 'File Attachment', factoryKey: 'fileAttachmentColumn'},
    'tbl_numericInput' : {name: 'Numeric Input', factoryKey: 'numericInputColumn'},
    'tbl_radioButton' : {name: 'Radio Button', factoryKey: 'radioButtonColumn'},
    'tbl_textArea' : {name: 'Text Area', factoryKey: 'textAreaColumn'},
    'tbl_textInput' : {name: 'Text Input', factoryKey: 'textInputColumn'},
    'tbl_timeInput' : {name: 'Time Input', factoryKey: 'timeInputColumn'}
};


class TableService {

    constructor() {
        this._columnMap = Immutable.Map( columnInfo );
    }

    getColumnInfo( type ) {
        const info = this._columnMap.get( type );
        return info;
    }

    showColumnProperties(rowid, model) {
        if (model) {
            model.set('selectedRowId', rowid, {silent: true});

            const colInfo = this.getColumnInfo(model.get('gridData')[rowid].attributes['type']);

            var fKey = model.get('gridData')[rowid].attributes['factoryKey'];
            var cType = colInfo.name + ' Column';
            let columnId = model.get('gridData')[rowid].attributes['id'];

            const opts = {factoryKey: fKey, colId: rowid, controlName: cType, id: columnId};

            // render properties sections
            viewManagerService.renderLayoutPropertyTabs(model, opts);
        } else {
            console.log(`BAD: tableService.showColumnProperties received undefined model.`)
        }

    }

    buildSelectList(model) {
        const self = this;
        var selectFields = [];
        let gridData = model.get('gridData');

        const hasCaptions = v => v.attributes.Property ? ' - Value' : '';

        _.forEach(gridData, v => {
            if (v) {
                const id = listService.getCleanedId(model.get('id'));
                const name = v.attributes.name;

                selectFields.push({
                    text: `${name} - Current Row${hasCaptions(v)}`,
                    id: id + '$cur_' + listService.getCleanedId(v.attributes.id)
                });

                selectFields.push({
                    text: `${name} - All Rows${hasCaptions(v)}`,
                    id: id + '$all_' + listService.getCleanedId(v.attributes.id)
                });

                if(hasCaptions(v)) {
                    selectFields.push({
                        text: `${name} - Current Row - Caption`,
                        id: id + '$cuc_' + listService.getCleanedId(v.attributes.id)
                    });

                    selectFields.push({
                        text: `${name} - All Rows - Caption`,
                        id: id + '$alc_' + listService.getCleanedId(v.attributes.id)
                    });

                }

            }
        });

        model.set('selectFields', selectFields, {silent: true});
    }

}

const tableService = new TableService();
export default tableService;
